<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        "hide-footer": "",
        id: "set-2-fa",
        centered: "",
        size: "sm",
        "no-close-on-backdrop": true,
      },
      model: {
        value: _vm.modalVisible,
        callback: function ($$v) {
          _vm.modalVisible = $$v
        },
        expression: "modalVisible",
      },
    },
    [
      _c("div", { staticClass: "modal-ui" }, [
        _c("div", { staticClass: "rc-modal-title head-top-25" }, [
          _vm._v(" " + _vm._s(_vm.$t("security.Secure-accout-title")) + " "),
        ]),
        _c("div", { staticClass: "email-desc-seq" }, [
          _vm._v(" " + _vm._s(_vm.$t("security.info-line-1")) + " "),
        ]),
        _c("div", { staticClass: "email-desc-seq" }, [
          _vm._v(" " + _vm._s(_vm.$t("security.info-line-2")) + " "),
        ]),
        _c(
          "div",
          { staticClass: "text-center" },
          [
            _c(
              "b-button",
              {
                staticClass: "mt-1 mb-1 min-120-btn",
                attrs: { variant: "primary" },
                on: { click: _vm.goTo2fa },
              },
              [
                _c("span", { staticClass: "mr-25 align-middle" }, [
                  _vm._v(_vm._s(_vm.$t("security.set-btn"))),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/components/Set2FA.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default ({
  render,
  staticRenderFns,
  components: {
    BButton: bootstrapvue["BButton"],
    BModal: bootstrapvue["BModal"],
    BLink: bootstrapvue["BLink"]
  },
  props: {
    modalVisible: Boolean
  },
  methods: {
    goTo2fa() {
      this.$router.push({
        name: "security",
        params: {
          lang: this.lang || undefined
        }
      });
      this.modalVisible = false;
    }
  }
});

//# sourceURL=webpack:///./src/layouts/components/Set2FA.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style>
.email-desc-seq {
  color: var(--text-black-color);
  font-size: 15px;
}[dir] .email-desc-seq {
  text-align: center;
  margin-bottom: 15px;
}
</style>
